import Input from "../../components/input";
import Button from "../../components/button";
import { Table } from "../../components/ui/table";
import AddIcon from "../../components/icons/add-icon";
import { useEffect, useState } from "react";

import DeleteIcon from "../../components/icons/delete-icon";
import ConfirmationCard from "../../components/ui/confirmation-card";
import Modal from "../../components/ui/modal";
import { useNavigate } from "react-router-dom";
import { getProcessingTeam, getProcessingTeamCount } from "src/firebase/admin.js";
import { doc, deleteDoc, setDoc } from "firebase/firestore";
import { handleToastMessage } from "src/js/handleToastMessage";
import { db } from "src/firebase/firebase";
import Loader from "../../components/loader";
import { useTranslation } from "react-i18next";
import Profile from "../../pages/profile/profile";
import { Pagination } from "@mui/material";
import OverlayLoader from "../../components/overlayLoader";

const pageSize = 200;

const ProcessingManagement = () => {
  const { t } = useTranslation(["home"]);
  const [activeDeletedId, setActiveDeletedId] = useState(null);
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [activeEditData, setActiveEditData] = useState(null);
  const [processingTeamList, setProcessingTeamList] = useState([]);
  const [filterProcessingTeamList, setFilterProcessingTeamList] = useState([]);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [totalCards, setTotalCards] = useState<number>(1);
  const [searchText, setSearchText] = useState<string>("");
  useEffect(() => {
    getProcessingTeamList();
  }, [currentPage, searchText]);

  useEffect(() => {
    getProcessing();
  }, []);

  const getProcessing = async () => {
    const result = await getProcessingTeamCount();
    setTotalCards(result);
  };

  const getProcessingTeamList = async () => {
    setIsLoading(true);
    let result = await getProcessingTeam(currentPage, pageSize, searchText);
    setIsLoading(false);
    result = result.map((item) => {
      return {
        ...item,
        id: item?.id,
        userName: `${item.firstName} ${item.lastName}`,
        email: item.email,
      };
    });
    setProcessingTeamList(result);
    setFilterProcessingTeamList(result);
  };

  const handleSearch = (value) => {
    setSearchText(value);
    setCurrentPage(1);
  };

  const handlePageChange = (
    event: React.ChangeEvent<unknown>,
    page: number
  ) => {
    console.log("value", page);
    setCurrentPage(page);
  };

  const columns = [
    // {
    //   title: (
    //     <div className="pl-1 flex justify-between items-center">
    //       <span>{t("ID")}</span>
    //     </div>
    //   ),
    //   dataIndex: "id",
    //   key: "id",
    //   width: 170,
    // },
    {
      title: (
        <div className="pl-1 flex justify-between items-center">
          <span>{t("User Name")}</span>
        </div>
      ),
      dataIndex: "userName",
      key: "userName",
      width: 170,
      render: (userName: string) => <div>{userName}</div>,
    },
    {
      title: (
        <div className="pl-1 flex justify-between items-center">
          <span>{t("Email ID")}</span>
        </div>
      ),
      dataIndex: "email",
      key: "email",
      width: 170,
    },
    {
      title: (
        <div className="pl-1 flex justify-between items-center">
          <span>{t("Date")}</span>
        </div>
      ),
      dataIndex: "date",
      render: (date: any) => (
        <div>{date ? new Date(date.seconds * 1000).toDateString() : ""}</div>
      ),
      key: "date",
      width: 170,
    },

    {
      title: (
        <div className="pl-1 flex justify-between items-center">
          <span>{t("Action")}</span>
        </div>
      ),
      dataIndex: "id",
      key: "id",
      width: 170,
      render: (id: string, row: any) => (
        <div className="flex gap-x-2">
          {row?.isEnable === true || row?.isEnable === undefined ? (
            <Button
              size="small"
              className="bg-red"
              onClick={() => setActiveDeletedId(row)}
            >
              {t("Disable")}
            </Button>
          ) : (
            <Button
              size="small"
              className="bg-green"
              onClick={() => setActiveDeletedId(row)}
            >
              {t("Enable")}
            </Button>
          )}
          <Button
            size="small"
            className="bg-green"
            onClick={() => setActiveEditData(row)}
          >
            {t("Edit")}
          </Button>
        </div>
      ),
    },
  ];

  const handleDelete = async () => {
    let _activeSupplier = activeDeletedId;
    _activeSupplier.isEnable =
      _activeSupplier.isEnable === true ||
      _activeSupplier.isEnable === undefined
        ? false
        : true;
    await setDoc(doc(db, "Accounts", _activeSupplier.id), _activeSupplier);
    getProcessingTeamList();
    setActiveDeletedId(null);
  };
  return (
    <div className="p-5">
      <div className="flex justify-between items-center mb-3">
        <h2 className="text-xl text-darkBlack font-semibold">
          {t("Processing")} {t("Management")}
        </h2>

        <Button
          className="ml-0 block"
          onClick={() => navigate("/admin/new-processing")}
        >
          {t("Add")}
          <span className="ml-3">
            <AddIcon />
          </span>
        </Button>
      </div>
      <div className="p-4 bg-white">
        <div className="flex justify-between items-center mb-3">
          <h1 className="text-darkGrey text-lg font-semibold ">
            {t("Processing")} {t("Team List")}
          </h1>
          <div className="flex gap-2 items-center">
            <Input
              name="keyword"
              placeholder={t("Search by keyword")}
              inputClassName="h-9"
              variant="solid"
              onChange={(e) => handleSearch(e.target.value)}
            />
          </div>
        </div>
        {isLoading && <OverlayLoader />}
        <Table
          tableLayout="fixed"
          columns={columns as any}
          emptyText="No data found"
          data={filterProcessingTeamList}
          rowKey="id"
          scroll={{ x: 1000 }}
          sticky={true}
          className="matrix"
          onHeaderRow={() => ({
            className: "header-title",
          })}
        />
        <Pagination
          className="w-full mt-10"
          count={Math.ceil(totalCards / pageSize)}
          onChange={handlePageChange}
        />
      </div>
      <Modal
        open={activeDeletedId ? true : false}
        onClose={() => setActiveDeletedId(null)}
      >
        <ConfirmationCard
          title={
            activeDeletedId?.isEnable === true ||
            activeDeletedId?.isEnable === undefined
              ? t("Disable this account")
              : t("Enable this account")
          }
          deleteBtnText="Yes"
          onCancel={() => setActiveDeletedId(null)}
          onDelete={handleDelete}
          description={
            activeDeletedId?.isEnable === true ||
            activeDeletedId?.isEnable === undefined
              ? t("Are you sure about disable this account?")
              : t("Are you sure about enable this account?")
          }
        />
      </Modal>
      <Modal
        open={activeEditData ? true : false}
        onClose={() => setActiveEditData(null)}
        className="w-full"
      >
        <Profile
          isShowSideBar={false}
          user={activeEditData}
          updateProfile={() => {
            setActiveEditData(null);
            getProcessingTeamList();
          }}
        />
      </Modal>
    </div>
  );
};
export default ProcessingManagement;
